export default __webpack_public_path__ + "static/media/whiteoak.ca0d2e5c.webp";